import React from "react";

const InformationIcon = ({ fill, stroke }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="22"
      viewBox="0 0 20 22"
    >
      <g
        id="Group_25"
        data-name="Group 25"
        transform="translate(-1004 -375.531)"
      >
        <g
          id="Ellipse_10"
          data-name="Ellipse 10"
          transform="translate(1004 377)"
          fill={fill ? fill : "#fff"}
          stroke={stroke ? stroke : "#e51717"}
          strokeWidth="1"
        >
          <circle cx="10" cy="10" r="10" stroke="none" />
          <circle cx="10" cy="10" r="9.5" fill="none" />
        </g>
        <text
          id="i"
          transform="translate(1011.986 392.531)"
          fill={fill ? fill : "#e51717"}
          fontSize="18"
          fontFamily="ScriptMTBold, Script MT"
        >
          <tspan x="0" y="0">
            i
          </tspan>
        </text>
      </g>
    </svg>
  );
};

export default InformationIcon;
